import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {storeToRefs} from 'pinia';
    import {useUser} from '../../user';
    import {computed} from 'vue';
    import {VJoyAvatar} from '@maltjoy/core-vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'FreelancerAvatar',
  setup(__props) {

    const userStore = useUser();
    const {userIdentities} = storeToRefs(userStore);

    const freelancerIdentity = userIdentities.value.find((identity) => {
        return identity.type === 'FREELANCE';
    });
    const freelancerPhoto = computed(() => {
        return freelancerIdentity?.photo ? `${freelancerIdentity.photo?.baseUrl}/${freelancerIdentity.photo?.name}` : undefined;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VJoyAvatar), {
    size: "small",
    "full-name": _unref(freelancerIdentity)?.fullName,
    "photo-url": freelancerPhoto.value,
    color: freelancerPhoto.value ? 'transparent' : 'secondary',
    class: _normalizeClass(["navbar-freelancer-avatar", {'navbar-freelancer-avatar--text': !freelancerPhoto.value}])
  }, null, 8, ["full-name", "photo-url", "color", "class"]))
}
}

})